import { ArrowCircleRight } from '@phosphor-icons/react';

export default ArrowCircleRight;
